module.exports = __webpack_public_path__ + "static/media/planimetry.97994977.svg";